import { render } from "./CardTransactionsTable.vue?vue&type=template&id=6772ae92&scoped=true"
import script from "./CardTransactionsTable.vue?vue&type=script&lang=js"
export * from "./CardTransactionsTable.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=6772ae92&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6772ae92"]])

export default __exports__